import { useState } from "preact/hooks";
import { loginAdmin } from "../api";

export function LoginPage() {
  const params = new URLSearchParams(window.location.search);
  const reason = params.get("reason");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(
    reason === "unauthorized" ? "Sua sessão expirou ou o acesso não foi autorizado. Entre novamente." : null,
  );
  const [loading, setLoading] = useState(false);

  async function submit(e: Event) {
    e.preventDefault();
    if (!email.trim() || !password.trim()) {
      setError("Preencha login e senha.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await loginAdmin(email, password);
      if (!result.ok) {
        setError(result.error === "invalid_credentials" ? "Login ou senha inválidos." : "Erro ao entrar.");
        return;
      }
      window.location.href = params.get("next") || "/conversas";
    } catch (err) {
      console.error(err);
      setError("Erro ao entrar.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main class="login-shell">
      <form class="login-panel" onSubmit={submit}>
        <div>
          <h1 class="login-title">WhereInRio</h1>
          <p class="login-subtitle">Dashboard operacional</p>
        </div>
        <label class="field">
          <span>E-mail</span>
          <input
            value={email}
            onInput={(e) => setEmail(e.currentTarget.value)}
            autocomplete="username"
            inputMode="email"
            autofocus
          />
        </label>
        <label class="field">
          <span>Senha</span>
          <input
            value={password}
            onInput={(e) => setPassword(e.currentTarget.value)}
            type="password"
            autocomplete="current-password"
          />
        </label>
        {error && <div class="state-error auth-alert" role="alert">{error}</div>}
        <button class="btn btn--primary" type="submit" disabled={loading}>
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </main>
  );
}
